// angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CurrencyMaskModule } from 'ng2-currency-mask';

// ngxs
import { NgxsModule } from '@ngxs/store';

// material
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';

// state
import { PaymentsState } from './state';

// pipes
import { UsStateNameTitleCasePipe } from './pipes';

// components
import {
  NewPaymentMethodDialogComponent,
  PaymentsSidebarComponent,
  SelectPaymentMethodComponent,
  UpdateBillingAddressDialogComponent,
} from './containers';
import {
  AddAddOnComponent,
  AdditionalServiceComponent,
  AddOnComponent,
  ClientPaymentSummaryComponent,
  PaymentActionRequirementDialogComponent,
  PaymentResultsDialogComponent,
  PaymentSummaryComponent,
  PaymentMethodGateComponent,
  PayWithoutInvoiceFormComponent,
  RecipientEmailsComponent,
  NewPaymentMethodFailedComponent
} from './components';

// payment platforms
import {
  StripeAddressElementComponent,
  StripePaymentElementComponent,
  StripeSelectNewPaymentMethodComponent,
  StripeSelectNewPaymentMethodTypeComponent,
  StripeSelectPaymentMethodComponent,
  StripeSelectSavedPaymentMethodComponent,
  StripeState,
} from './platforms';

// aiwyn
import { SharedModule } from '@aiwyn/shared';

@NgModule({
  declarations: [
    // containers
    NewPaymentMethodDialogComponent,
    PaymentsSidebarComponent,

    // components
    AddAddOnComponent,
    AdditionalServiceComponent,
    AddOnComponent,
    PaymentMethodGateComponent,
    PaymentSummaryComponent,
    PayWithoutInvoiceFormComponent,
    SelectPaymentMethodComponent,
    NewPaymentMethodFailedComponent,

    StripeAddressElementComponent,
    StripePaymentElementComponent,
    StripeSelectNewPaymentMethodComponent,
    StripeSelectNewPaymentMethodTypeComponent,
    StripeSelectPaymentMethodComponent,
    StripeSelectSavedPaymentMethodComponent,

    // pipes
    UsStateNameTitleCasePipe,
    RecipientEmailsComponent,
    PaymentResultsDialogComponent,
    UpdateBillingAddressDialogComponent,
    PaymentActionRequirementDialogComponent,
    ClientPaymentSummaryComponent,
  ],
  imports: [
    // angular
    CommonModule,
    CurrencyMaskModule,
    ReactiveFormsModule,

    // ngxs
    NgxsModule.forFeature([PaymentsState, StripeState]),

    // material
    MatCheckboxModule,
    MatDialogModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatTooltipModule,

    // aiwyn
    SharedModule,
  ],
  exports: [
    // components
    PaymentsSidebarComponent,
    SelectPaymentMethodComponent,

    // pipes
    PaymentSummaryComponent,
    RecipientEmailsComponent,
    UsStateNameTitleCasePipe,
  ],
})
export class PaymentsModule {}
